import { getIp } from "@/api/api.js";

// 初始化神策SDK============================start
var that = this;
var sensors = require('sa-sdk-javascript');
sensors.registerPage({
  time: Date.parse(new Date()), // 当前时间戳
  source: '抽题组卷h5', // 来源 项目名
  location: ''
})
sensors.init({
  //埋点的数据上传接口
  server_url: 'https://hzstg.ksbao.com/mypro?url=https://cdp-ubs.ksbao.com/ksbao/toolslog', //六楼的
  // server_url: 'https://answerconfirm.ksbao.com/interface-tools-test-0.0.1/protocolConversion/httpToHttps1', //陈zj
  is_track_single_page: true, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  get_vtrack_config: true,
  show_log: false,
  send_type: 'ajax',
  header: 'Content-Type: application/json',
  heatmap: {
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    //是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'not_collect',
    //需要采集的标签
    collect_tags: {
      div: {
        max_level: 3 // 默认是 1，即只支持叶子 div。可配置范围是 [1, 2, 3],非该范围配置值，会被当作 1 处理。
      },
      li: true,
      span: true,
      img: true
    },

    //不需要采集的标签
    //此参数针对预置 $WebClick 事件（包括 quick('trackHeatMap') quick('trackAllHeatMap') 触发的）生效。
    collect_element: function (element_target) {
      // 如果这个元素有属性sensors-disable=true时候，不采集。
      if (element_target.getAttribute('bucaiji') === 'true' ||
        element_target.className.match(new RegExp('(\\s|^)' + 'van-nav-bar__left' + '(\\s|$)')) ||
        element_target.className.match(new RegExp('(\\s|^)' + 'van-icon-arrow-left' + '(\\s|$)')) ||
        element_target.className.match(new RegExp('(\\s|^)' + 'icon-aliarrow-left-copy' + '(\\s|$)')) ||
        element_target.className.match(new RegExp('(\\s|^)' + 'checkedBox' + '(\\s|$)')) ||
        element_target.className.match(new RegExp('(\\s|^)' + 'checkedBox-right' + '(\\s|$)')) ||
        element_target.className.match(new RegExp('(\\s|^)' + 'van-field__control' + '(\\s|$)'))
      ) {
        return false;
      } else {
        return true;
      }
    },
    //不需要采集的input
    collect_input: function (element_target) {
      //例如如果元素的 id 是a，就采集这个元素里的内容。
      // if(element_target.id === 'a'){
      //     return true;
      // }

      // return false;
    },

    //採集到的標籤，通過判斷重新設置名字
    //此参数针对预置 $WebClick 事件（包括 quick('trackHeatMap') quick('trackAllHeatMap') 触发的）生效。
    custom_property: function (element_target) {
      //比如您需要给有 data=test 属性的标签的点击事件增加自定义属性 name:'aa' ，则代码如下：
      var element_name = '';
      var location = '';
      var obj = {};
      if (element_target.getAttribute('resetname') === 'true') {
        obj.$element_name = element_target.getAttribute('newname')
      }
      if (element_target.getAttribute('resetlocation') === 'true') {
        obj.location = element_target.getAttribute('newlocation')
      }
      if (element_target.getAttribute('resetvideoid') === 'true') {
        obj.videoid = element_target.getAttribute('newvideoid')
      }
      if (element_target.getAttribute('test_ids') === 'true') {
        obj.test_id = element_target.getAttribute('test_id')
      }
      if (element_target.getAttribute('element_namesb') === 'true') {
        obj.$element_name = element_target.getAttribute('element_names')
      }
      return obj;
    },
  }
});

function hasClass(obj, cls) {
  if (obj.className) {
    return obj.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
  }
  return false;
}
// 另外，如果想加额外的属性，可以如下方式（添加 platform 属性为 h5）
//默认返回0 初始化埋點信息


//已登錄

//
var u = navigator.userAgent;

var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //如果输出结果是true就判定是android终端或者uc浏览器

var os = getOSName();


var borwser = myBrowser();
localStorage.setItem('borwser', borwser)
var agentCode = localStorage.getItem('agentCode');
let data = {
  configName: localStorage.getItem('questionsName'), //试卷名
  configID: localStorage.getItem('configID'), //试卷id
  browser: borwser, //浏览器类型
  appName: localStorage.getItem('appName'), //科目名
  styleConfigName: localStorage.getItem('styleConfigName'), //题目类型
  clientType: "抽题组卷H5",

}
if (localStorage.getItem('info')) {
  data.userId = localStorage.getItem('userID');
  data.appid = localStorage.getItem('appid');
  data.agentCode = agentCode; //代理商编号
  data.phoneNumber = localStorage.getItem("sj");
}
sensors.registerPage(data)
getIp({}).then((res) => {
  if (res.data.code == 200) {
    sensors.registerPage({
      city: res.data.data.city,
      province: res.data.data.province,
      ip: res.data.data.ip,
    })
  }
})
sensors.quick('autoTrack');
sensors.use('PageLeave');
function myBrowser() {
  var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
  var isOpera = userAgent.indexOf("Opera") > -1; //判断是否Opera浏览器
  var isIE = userAgent.indexOf("compatible") > -1 &&
    userAgent.indexOf("MSIE") > -1 && !isOpera; //判断是否IE浏览器
  var isEdge = userAgent.indexOf("Edge") > -1; //判断是否IE的Edge浏览器
  var isFF = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
  var isSafari = userAgent.indexOf("Safari") > -1 &&
    userAgent.indexOf("Chrome") == -1; //判断是否Safari浏览器
  var isChrome = userAgent.indexOf("Chrome") > -1 &&
    userAgent.indexOf("Safari") > -1; //判断Chrome浏览器

  if (isIE) {
    var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
    reIE.test(userAgent);
    var fIEVersion = parseFloat(RegExp["$1"]);
    if (fIEVersion == 7) {
      return "IE7";
    } else if (fIEVersion == 8) {
      return "IE8";
    } else if (fIEVersion == 9) {
      return "IE9";
    } else if (fIEVersion == 10) {
      return "IE10";
    } else if (fIEVersion == 11) {
      return "IE11";
    } else {
      return "0";
    } //IE版本过低
    return "IE";
  }
  if (isOpera) {
    return "Opera";
  }
  if (isEdge) {
    return "Edge";
  }
  if (isFF) {
    return "FF";
  }
  if (isSafari) {
    return "Safari";
  }
  if (isChrome) {
    return "Chrome";
  }

}

function getOSName() {
  var userAgent = navigator.userAgent;
  var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1; //android终端
  if (isAndroid)
    return "android"


  var isIOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isIOS)
    return "ios"



  var userAgent = navigator.userAgent;
  var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
  if (isMac) return "Mac";

  var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
  var isUnix = (navigator.platform == "X11") && !isWin && !isMac;
  if (isUnix) return "Unix";

  var isLinux = (String(navigator.platform).indexOf("Linux") > -1);
  if (isLinux) return "Linux";

  if (isWin) {
    var findFlag = userAgent.indexOf("Windows NT 5.0") > -1 || userAgent.indexOf("Windows 2000") > -1;
    if (findFlag) return "Win2000";
    var findFlag = userAgent.indexOf("Windows NT 5.1") > -1 || userAgent.indexOf("Windows XP") > -1;
    if (findFlag) return "WinXP";
    var findFlag = userAgent.indexOf("Windows NT 5.2") > -1 || userAgent.indexOf("Windows 2003") > -1;
    if (findFlag) return "Win2003";
    var findFlag = userAgent.indexOf("Windows NT 6.0") > -1 || userAgent.indexOf("Windows Vista") > -1;
    if (findFlag) return "WinVista";
    var findFlag = userAgent.indexOf("Windows NT 6.1") > -1 || userAgent.indexOf("Windows 7") > -1;
    if (findFlag) return "Win7";
    var findFlag = userAgent.indexOf("Windows NT 6.2") > -1 || userAgent.indexOf("Windows 8") > -1;
    if (findFlag) return "Win8";
    var findFlag = userAgent.indexOf("Windows NT 6.3") > -1 || userAgent.indexOf("Windows 8.1") > -1;
    if (findFlag) return "Win8.1";
    var findFlag = userAgent.indexOf("Windows NT 6.4") > -1 || userAgent.indexOf("Windows 10") > -1;
    if (findFlag) return "Win10";
    return 'windows';
  }

  return "other";
}

// 初始化神策SDK============================end
export default sensors